import React from 'react';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import VisibilityIcon from '@material-ui/icons/Visibility';

interface ReadStatusButtonProps {
  isReading: boolean;
  isRead: boolean;
  onClick: () => void;
}

const ReadStatusButton: React.FC<ReadStatusButtonProps> = ({ isReading, isRead, onClick }) => {
  return (
    <Button
      variant="contained"
      color={isRead ? 'secondary' : 'primary'}
      style={{
        marginTop: '0px',
        pointerEvents: isRead ? 'none' : 'auto',
      }}
      size="small"
      onClick={onClick}
      disabled={isReading || isRead}
    >
      {isReading ? (
        <CircularProgress size={20} color="inherit" />
      ) : isRead ? (
        <>
          <CheckIcon fontSize="small" color="inherit" />
          <Typography variant="body2" display="inline" style={{ marginLeft: '5px' }}>
            既読
          </Typography>
        </>
      ) : (
        <>
          <VisibilityIcon fontSize="small" color="inherit" />
          <Typography variant="body2" display="inline" style={{ marginLeft: '5px' }}>
            既読
          </Typography>
        </>
      )}
    </Button>
  );
};

export default ReadStatusButton;
